export default "__VITE_ASSET__Z37bU9TX__"